import { Card, Container, Ratio } from "react-bootstrap";

import { Back } from "@/ui/Back";
import cn from "classnames";
import { format } from "date-fns";
import { Parallax } from "react-scroll-parallax";
import classes from "./styles.module.scss";

export default function ({
  className,
  featured,
  title,
  topics,
  image,
  published,
  author,
  EditableHtml,
  EditableImage,
  theme = "light",
}) {
  const [topic] = topics;

  return (
    <Card className={cn(className, classes.BlogPostHero)} data-bs-theme={theme}>
      <Parallax translateY={[-80, 40]}>
        <Card.Img as={Ratio} aspectRatio={34}>
          <>{image && <EditableImage path="image" src={image} size="1920x547" />}</>
        </Card.Img>
      </Parallax>
      <Card.ImgOverlay className="d-flex flex-column text-center align-items-center justify-content-center pb-4 pb-md-5 pt-5">
        <Container fluid="md" className="pt-5 pb-md-5">
          <Back href="/blog" className="mb-4 mb-md-0">
            Back to Blog
          </Back>
          {featured && (
            <Card.Header className="small mb-4">
              <i /> Featured Blog
            </Card.Header>
          )}
          <Card.Title as={EditableHtml} path="title" tag="h1">
            <span dangerouslySetInnerHTML={{ __html: title }} />
          </Card.Title>
          <Card.Footer className="flex-column flex-md-row">
            {topic && <span>{topic.name}</span>}
            <span className="d-none d-md-block">/</span>
            <span>
              <span>
                {Date.parse(published) ? format(new Date(published), "d MMM yyyy") : published}
              </span>
            </span>
            {author && (
              <>
                <span className="d-none d-md-block">/</span>
                <span>{author.name}</span>
              </>
            )}
          </Card.Footer>
        </Container>
      </Card.ImgOverlay>
    </Card>
  );
}
